import { ConfigurationGroupType, ConfigurationGroupOptionType } from 'shared-types/SpaPackage';

export const findOptionFromConfigGroups = (
  configGroups: ConfigurationGroupType[],
  optionId: number
): ConfigurationGroupOptionType | undefined => {
  return configGroups
    .flatMap((conf) => (Array.isArray(conf?.options) ? conf.options : []))
    .find((option) => option.id === optionId);
};
